const styles = (theme) => ({
  root: {
    padding: theme.spacing(2),
    outline: 'none',
  },
  select: {
    width: '100%',
  },
  table: {
    width: '100%',
  },
  form: {
    width: '100%',
  },
  tableCellFlex: {
    display: 'flex',
    justifyContent: 'space-around',
  },
  tableButton: {
    color: '#263238',
    fontSize: '12px',
  },
  ellipsisTable: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '9rem',
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    outline: 0,
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  paperModal: {
    width: '70%',
    backgroundColor: '#fff',
    borderWidth: 0,
    outline: 'none',
  },
  paperDescription: {
    backgroundColor: '#F1F1F1',
    padding: theme.spacing(2),
  },
  label: {
    marginBottom: '10px',
    marginTop: 10,
  },
  gridModal: {
    padding: theme.spacing(2),
  },
  button: {
    margin: theme.spacing(1),
  },
  multiSelect: {
    fontSize: '12px',
    fontFamily: 'Roboto',
  },
  selectAction: {},
  justifyFlexEnd: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  fullHeight: {
    height: '100%',
    minHeight: '100%',
  },
  otherSource: {
    color: theme.palette.primary.dark,
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.8,
    },
  },
  otherInputSource: {
    backgroundColor: theme.palette.text.backgroundInputColor,
    margin: theme.spacing(1),
  },
  redBackground: {
    backgroundColor: theme.palette.error.main,
  },
  autoComplete: {
    backgroundColor: theme.palette.background.paper,
  },
})

export default styles
